/**
 * @typedef {Object} OutputField
 * @property {string} name - Field identifier
 * @property {string|function} label - Display label or function returning label
 * @property {function} [checked] - Function determining if field is selected by default
 * @property {function} [visible] - Function determining if field should be shown
 * @property {boolean} [forceChecked] - If true, field is always selected and cannot be unchecked
 * @property {function} [disabled] - Function determining if fields should be disabled
 */

const placeOfServiceOutputFields = [
  {
    name: "npi",
    label: ({ common }) =>
      common?.providerType === "physician"
        ? "Physician NPI"
        : "Organization NPI",
    checked: ({ common }) => !!common?.outputs?.npi
  },
  {
    name: "name",
    label: ({ common }) =>
      common?.providerType === "physician"
        ? "Physician Name"
        : "Organization Name",
    checked: ({ common }) => !!common?.outputs?.name
  },
  {
    name: "classification",
    label: ({ common }) =>
      common?.providerType === "physician"
        ? "Physician Classification"
        : "Organization Classification",
    checked: ({ common }) => !!common?.outputs?.classification
  },
  {
    name: "specialization",
    label: ({ common }) =>
      common?.providerType === "physician"
        ? "Physician Specialization"
        : "Organization Specialization",
    checked: ({ common }) => !!common?.outputs?.specialization
  },

  {
    name: "hospitalAffiliationIds",
    label: "Hospital Affiliation Ids",
    visible: ({ common }) => common?.providerType === "physician",
    checked: ({ common }) => !!common?.outputs?.hospitalAffiliationIds
  },
  {
    name: "hospitalAffiliationNames",
    label: "Hospital Affiliation Names",
    visible: ({ common }) => common?.providerType === "physician",
    checked: ({ common }) => !!common?.outputs?.hospitalAffiliationNames
  },
  {
    name: "groupPracticeIds",
    label: "Group Practice Ids",
    visible: ({ common }) => common?.providerType === "physician",
    checked: ({ common }) => !!common?.outputs?.groupPracticeIds
  },
  {
    name: "groupPracticeNames",
    label: "Group Practice Names",
    visible: ({ common }) => common?.providerType === "physician",
    checked: ({ common }) => !!common?.outputs?.groupPracticeNames
  },

  {
    name: "address",
    label: "Address",
    checked: ({ common }) => !!common?.outputs?.address
  },
  {
    name: "city",
    label: "City",
    checked: ({ common }) => !!common?.outputs?.city
  },
  {
    name: "zipCode",
    label: "ZIP Code",
    checked: ({ common }) => !!common?.outputs?.zipCode
  },

  {
    name: "placeOfService",
    label: "Place of Service",
    forceChecked: true
  },

  {
    name: "source",
    label: "Source",
    checked: ({ common }) => !!common?.outputs?.source
  },

  {
    name: "distinctClaimsCount",
    label: "Count of Distinct Claims",
    checked: ({ common }) => !!common?.outputs?.distinctClaimsCount
  },
  {
    name: "distinctPatientsCount",
    label: "Count of Distinct Patients",
    checked: ({ common }) => !!common?.outputs?.distinctPatientsCount
  },
  {
    name: "proceduresCount",
    label: "Count of Procedures",
    visible: ({ selectors }) => !!selectors?.isAllPayer,
    checked: ({ common }) => !!common?.outputs?.proceduresCount
  },
  {
    name: "sumCharges",
    label: "Sum of Charges",
    checked: ({ common }) => !!common?.outputs?.sumCharges
  }
];

export default placeOfServiceOutputFields;
